import { Routes } from '@angular/router'
import { AuthGuardWithForcedLogin } from 'src/domain/guards/auth.guard'

export const routes: Routes = [
	{
		path: '',
		canActivate: [AuthGuardWithForcedLogin],
		loadComponent: () => import('./layouts/master-layout/master-layout.component').then((c) => c.MasterLayoutComponent),
		children: [
			{
				path: 'subscription',
				loadComponent: () => import('./pages/subscription/subscription.component').then((c) => c.SubscriptionComponent),
				children: [
					{
						path: ':id',
						loadComponent: () =>
							import('./pages/subscription/subscription-detail/subscription-detail.component').then(
								(c) => c.SubscriptionDetailComponent,
							),
					},
				],
			},
			{
				path: 'customer',
				loadComponent: () => import('./pages/customer/customer.component').then((c) => c.CustomerComponent),
			},
			{
				path: 'invoice',
				loadComponent: () => import('./pages/invoice/invoice.component').then((c) => c.InvoiceComponent),
				children: [
					{
						path: ':id',
						loadComponent: () =>
							import('./pages/invoice/invoice-view-pdf/invoice-view-pdf.component').then(
								(c) => c.InvoiceViewPdfComponent,
							),
					},
				],
			},
			{
				path: 'product',
				loadComponent: () => import('./pages/product/product.component').then((c) => c.ProductComponent),
			},
			{ path: '', redirectTo: '/subscription', pathMatch: 'full' },
		],
	},
	{ path: 'portal', loadComponent: () => import('./pages/portal/portal.component').then((c) => c.PortalComponent) },
	{ path: 'webview', loadComponent: () => import('./pages/webview/webview.component').then((c) => c.WebviewComponent) },
	{ path: 'partner', loadComponent: () => import('./pages/partner/partner.component').then((c) => c.PartnerComponent) },
	{
		path: 'crisp-chat',
		loadComponent: () => import('./pages/crisp-chat/crisp-chat.component').then((c) => c.CrispChatComponent),
	},
	{
		path: 'm-subscription',
		loadComponent: () =>
			import('./pages/m-subscription/m-subscription.component').then((c) => c.MobileSubscriptionComponent),
	},
	{ path: '**', redirectTo: '' },
]
